
<template>
  <v-form ref="form" lazy-validation>
    <v-text-field v-model="building.name" :readonly="read_only" :rules="required" 
     label="Nome da obra" prepend-icon="mdi-office-building"></v-text-field>
    <v-text-field v-model="building.comment" :readonly="read_only" 
     label="Comentário sobre obra" prepend-icon="mdi-comment"></v-text-field>
  </v-form>
</template>

<script>
import validations from '@/mixins/validations.js'
export default {
  name: 'BuildingForm',
  mixins:[validations],
  data() {
    return {
    }
  },
  props:{
    building:{
      required: true,
      type: Object,
    },
    read_only:{
      type: Boolean,
      default: false,
    }
  },
  methods:{
    validate(){
      return this.$refs.form.validate()
    },
  },
}
</script>

<style scoped>

</style>